import { CSSTransition } from 'react-transition-group';

import { useSelector } from '_common/hooks';
import IntlErrorBoundary from '_common/components/IntlErrorBoundary/IntlErrorBoundary';

import Options from './Options/Options';
import Header from './Header/Header';

import styles from './Menu.module.scss';
import { useRef } from 'react';

const Menu = () => {
  const menu = useSelector((state) => state.sidebar.menu);
  const nodeRef = useRef<HTMLDivElement>(null);

  const animationsClassNames = {
    enter: styles.enter,
    enterActive: styles.enterActive,
    enterDone: styles.enterDone,
    exit: styles.exit,
    exitActive: styles.exitActive,
    exitDone: styles.exitDone,
  };

  return (
    <CSSTransition
      in={menu.isOpen}
      timeout={150}
      classNames={animationsClassNames}
      nodeRef={nodeRef}
    >
      <div
        className={`${styles.root} ${menu.activeMenu === 'tenantSettings' && styles.tenantSettings}`}
        ref={nodeRef}
      >
        <IntlErrorBoundary size="l" variant="white" style={{ margin: 'auto' }}>
          <>
            <Header />
            <Options />
          </>
        </IntlErrorBoundary>
      </div>
    </CSSTransition>
  );
};

export default Menu;
